import { Card } from '@/components/ui/card';
import ShineBorder from '@/components/ui/shine-border';
import { TopMediaItem } from '@/hooks/useReport';
import { memo } from 'react';

interface ReportMediaCardProps {
  media: TopMediaItem;
  number: number;
  isTopPerformer?: boolean;
}

export const ReportMediaCard = memo(
  ({ media, number, isTopPerformer }: ReportMediaCardProps) => {
    const reach = media.metrics.reach?.toString() || '0';
    const likes = media.metrics.like_count?.toString() || '0';
    const comments = media.metrics.comments_count?.toString() || '0';

    const content = (
      <div className="flex flex-col gap-3">
        <div
          className={`text-lg font-medium ${isTopPerformer ? 'text-primary' : ''}`}>
          #{number}
          {isTopPerformer ? ' Top Performer' : ''}
        </div>

        <div className="aspect-square bg-gray-200 rounded-lg relative">
          <img
            src={
              media.thumbnail_url ||
              media.media_url ||
              'https://placehold.co/400'
            }
            alt="Post thumbnail"
            className="aspect-square object-cover rounded-lg"
          />
          <div className="absolute bottom-0 left-0 p-4 w-full bg-gradient-to-t from-black/60 to-transparent rounded-b-lg">
            <h3 className="text-white text-sm font-medium line-clamp-2">
              {media.caption || media.media_description || 'Untitled Post'}
            </h3>
          </div>
        </div>

        <div className="flex flex-col space-y-3">
          <div className="flex justify-between items-center">
            <p className="text-sm text-gray-600">Reach</p>
            <p className="text-sm">{Number(reach).toLocaleString()}</p>
          </div>
          <div className="flex justify-between items-center">
            <p className="text-sm text-gray-600">Likes</p>
            <p className="text-sm">{Number(likes).toLocaleString()}</p>
          </div>
          <div className="flex justify-between items-center">
            <p className="text-sm text-gray-600">Comments</p>
            <p className="text-sm">{Number(comments).toLocaleString()}</p>
          </div>
        </div>
      </div>
    );

    return isTopPerformer ? (
      <ShineBorder className="relative flex flex-col items-center justify-center overflow-hidden rounded-lg border bg-background p-0">
        <Card className="p-5 h-max transition-all w-full">{content}</Card>
      </ShineBorder>
    ) : (
      <Card className="p-5 h-max transition-all w-full">{content}</Card>
    );
  },
);
